const SDK_VERSION = '8.34.0';
export { SDK_VERSION };